<template>
  <!--  VISTA LISTAR-->
  <template v-if="view === 'listar_1'">
    <div class="text-xl font-bold w-full sm:w-auto text-center"></div>
    <template v-if="loadData.estado_cargue == 1">
      <CreateUpdateReservasComponent :view="view" :paginate="paginate" :selected-data="selectedData" :mainListCollectionData="mainListCollectionData"
        :load-data="loadDataReserva" :custom-update-load-data="customUpdateLoadData" :auth-token="authToken"
        :list-api="listApi" :queries="queries"
        @updateValues="(res) => { $emit('updateValues', {'view': res.view, 'estado_cargue': this.loadData.estado_cargue}); return setupUpdateValues({'view': res.view, 'estado_cargue': this.loadData.estado_cargue}) }"
        :collectionReservas="collectionReservas">
      </CreateUpdateReservasComponent>
      <ReservasSegundoCargueComponent :mainListCollectionData="mainListCollectionData" :auth-token="authToken"
        @updateValues="(res) => {
          $emit('updateValues', { 'estado_cargue': res.estado_cargue }); return setupUpdateValues({'estado_cargue': this.loadData.estado_cargue})
        }" :selected-data="selectedData">
      </ReservasSegundoCargueComponent>
    </template>

    <template v-if="loadData.estado_cargue == 2">
      <CreateUpdateReservasComponent :view="view" :paginate="paginate" :selected-data="selectedData"
        :load-data="loadDataReserva" :custom-update-load-data="customUpdateLoadData" :auth-token="authToken"
        :list-api="listApi" :queries="queries" :mainListCollectionData="mainListCollectionData"
        @updateValues="(res) =>  { $emit('updateValues', {'view': res.view, 'estado_cargue': this.loadData.estado_cargue}); return setupUpdateValues({'view': res.view, 'estado_cargue': this.loadData.estado_cargue})}"
        :collectionReservas="collectionReservas">
      </CreateUpdateReservasComponent>
      <ReservasTercerCargueComponent :mainListCollectionData="mainListCollectionData" :auth-token="authToken"
        @updateValues="(res) => {
          $emit('updateValues', { 'estado_cargue': res.estado_cargue }); return setupUpdateValues({'estado_cargue': this.loadData.estado_cargue})}" :selected-data="selectedData">
      </ReservasTercerCargueComponent>
    </template>

    <!--    VISTA CREAR - ACTUALIZAR-->
    <template v-if="loadData.estado_cargue == 3">
      <CreateUpdateReservasComponent :view="view" :paginate="paginate" :selectedData="selectedData" :loadData="loadData"
        :custom-update-load-data="customUpdateLoadData" :auth-token="authToken" :list-api="listApi"
        :mainListCollectionData="mainListCollectionData" :queries="queries"
        @updateValues="(res) => { $emit('updateValues', {'view': res.view, 'estado_cargue': this.loadData.estado_cargue}); return setupUpdateValues({'view': res.view, 'estado_cargue': this.loadData.estado_cargue})}"
        :collectionReservas="collectionReservas">
      </CreateUpdateReservasComponent>
    </template>

    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
      @updateValues="setupUpdateValues">
    </FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedReserva" :table-columns="tableColumns"
      :collection-data="collectionReservas" :auth-token="authToken" :list-api="listApi"
      :custom-update-collection-data="customUpdateCollectionData" :isUpdateHidden="true"
      :updatePermission="'update_reservas_presupuestales'" @updateValues="setupUpdateValues">
      <template v-slot="{ data }">
        <button class="items-center px-2 py-2 text-white bg-yellow-500 rounded-md hover:bg-yellow-600 focus:outline-none"
          @click="view = 'listar_2'; selectedManualUpdate.id = data.id">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
      </template>
    </TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
      @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <template v-if="view === 'listar_2'">
    <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">{{
      tituloIngresoManualPasivo }}</h1>
    <ReservasActualizaManualComponent :mainListCollectionData="mainListCollectionData" :load-data="loadData"
      :paginate="paginate" :entity="entity" :custom-list-data="customListData" :auth-token="authToken"
      :custom-update-collection-data="customUpdateLoadData" :custom-update-value-data="customUpdateValueData"
      :collection-reservas="collectionReservas" :data="selectedManualUpdate"
      @updateValues="(values) => { $emit('updateValues', values); setupUpdateValues(values) }">
    </ReservasActualizaManualComponent>
  </template>
</template>

<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import TableComponent from "@/layouts/main/TableComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import { useLayoutMain } from "@/layouts/main";
import { copiaProfunda, separateNumberByComma } from "@/common/constants";
import CreateUpdateReservasComponent from "@/components/reservas/components/CreateUpdateReservasComponent";
import ReservasSegundoCargueComponent from "./ReservasSegundoCargueComponent";
import ReservasTercerCargueComponent from "./ReservasTercerCargueComponent"
import ReservasActualizaManualComponent from "./ReservasActualizaManualComponent"

export default {
  name: 'ReservasCrearActualizarComponent',
  props: ['selectedData', 'loadData','collectionData','customListData','customUpdateValueData'],
  emits: ['updateValues'],
  components: {
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateReservasComponent,
    ReservasActualizaManualComponent,
    ReservasSegundoCargueComponent,
    ReservasTercerCargueComponent,
  },
  data: function () {
    return {
      Object: Object,
      title: 'Vigencias SIAFF',
      tituloIngresoManualPasivo: 'Actualización Manual Pasivo Exigible',
      entity: { gender: 'm', value: 'Pasivo Exigible' },
      ReservasActualizaManualComponent: 'ReservasActualizaManualComponent',
      ReservasSegundoCargueComponent: 'ReservasSegundoCargueComponent',
      ReservasTercerCargueComponent: 'ReservasTercerCargueComponent',

      tableColumns: {
        'rp': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'RP'
        },
        'fecha': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha'
        },
        'id_rubro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Codigo Rubro'
        },
        'nombre_rubro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Rubro'
        },
        'cdp': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'CDP'
        },
        'codigo_fuente': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Codigo Fuente Concreta'
        },
        'nombre_fuente_macro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Fuente Macro'
        },
        'nombre_fuente': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Fuente Concreta'
        },
        'codigo_contrato': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Codigo Contrato'
        },
        'concepto_contrato': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Concepto Contrato'
        },
        'codigo_beneficiario': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Identificacion Beneficiario (NIT/CC)'
        },
        'beneficiario': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Beneficiario'
        },
        'valor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor Pasivo Exigible'
        },
        'valor_actual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor en Saldo'
        },
        'secretaria_ejecutora': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Ente Ejecutor'
        },
        'nombre_macro_ejecutor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Macro Ejecutor'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        },
        'estado': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: false,
          value: 'Estado'
        }
      }
    }
  },

  async setup(props) {
    const authStored = useAuth();
    const view = ref('listar_1');
    const collectionReservas = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedReserva = ref({
      id: '',
      nombre_reserva: '',
      estado_cargue: '',
      estado: ''
    });
    const selectedManualUpdate = ref({
      id: '',
    })
    const loadDataReserva = ref({
      nombre_reserva: '',
      estado_cargue: '',
      rp: '',
      fecha: '',
      id_rubro: '',
      nombre_rubro: '',
      codigo_fuente: '',
      nombre_fuente: '',
      codigo_contrato: '',
      concepto_contrato: '',
      codigo_beneficiario: '',
      beneficiario: '',
      valor: '',
      valor_actual: '',
      secretaria_ejecutora: '',
      cdp: '',
      macro_ejecutor:'',
    });

    const listApi = reactive({
      create: process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_CREATE,
      list: process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_FINDALL,
      update: process.env.VUE_APP_NEST_TRANSFERENCIA_UPDATECARGUE,
      updateState: process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_UPDATESTATE
    });
    /**
     * Función que se encarga de actualizar los datos de la colección de reservas.
     * @function
     * @returns {Array} - Array con los datos actualizados de la colección de reservas.
     */
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionReservas.value);
      for (const copyData of copyCollectionData) {
        copyData['created_at'] = copyData['created_at'].split('T')[0];
        for(const key of ['valor_actual', 'valor']){
          copyData[key] = separateNumberByComma(copyData[key])
        }
        if (copyData['contrato'] && copyData['contrato']['valor']) {
          copyData['contrato']['valor'] = separateNumberByComma(copyData['contrato']['valor'])
        }
      }
      return copyCollectionData;
    };

    const customUpdateLoadData = () => {
      loadDataReserva.value.usuario_id = JSON.parse(localStorage.getItem("user")).id;
    };

    /**
     * Función asíncrona que se encarga de obtener la lista de usuarios.
     * @function
     * @async
     * @returns {Array} - Array con los datos de la lista de usuarios.
     */
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      mainListCollectionData
    } = await useLayoutMain(view, collectionReservas, authToken, selectedReserva, loadDataReserva, listApi, { where: 'estado=1 AND id_cargue_siaff=' + props.selectedData.id });
    return {
      view,
      collectionReservas,
      authToken,
      selectedReserva,
      loadDataReserva,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      mainListCollectionData,
      customUpdateCollectionData,
      customUpdateLoadData,
      selectedManualUpdate,
    };
  }
};
</script>
